import * as React from 'react';
/**
 *
 * Original name: thumbs down
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=40733%3A10866
 *
 */
export const ThumbsDownFill = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.866 14.01h-2.55l.385 2.11a2.876 2.876 0 0 1-2.83 3.39h-.795l-.92-3.68a1.17 1.17 0 0 0-.185-.4c-.09-.12-.2-.22-.325-.295l-1.37-.825c-.33-.2-.71-.305-1.095-.305H5.02V7.29l3.885-1.945c.45-.225.95-.34 1.455-.345h5.595c.54 0 1.06.195 1.47.545.41.35.675.84.755 1.37l.83 4.535c.04.315.015.64-.075.945-.095.305-.25.59-.46.83-.215.245-.475.44-.77.57a2.251 2.251 0 0 1-.935.205h-2.1", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
